import { useContext } from 'react'

import StretchContext, { StretchType } from '@contexts/storyTellingFullWidth'

const useShouldStretch = (): StretchType => useContext(StretchContext)

export default useShouldStretch
